import React, { memo } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { ApplicationAction, BusinessPage } from "core/constants";
import UrlUtils from "core/lib/url-utils";
import SignIn from "components/sign-in";
import AuthStyleWrapper from "components/ui/auth-style-wrapper";
import AccountCreatedConfirmation from "../self-service/account/campaign/account-created-confirmation";
import AccountWaitingApproval from "self-service/account/campaign/account-waiting-approval";
import CampaignSignUp from "self-service/account/campaign/sign-up";
import ChildSignUp from "self-service/account/delegation-of-authority/child-sign-up";
import AccountNotFound from "self-service/account/link-up/components/account-not-found";

const RegistrationLayout = () => {
    const navigate = useNavigate();

    const retry = (e: any) => navigate(BusinessPage.campaignSignIn);

    const returnUrl = `${UrlUtils.getRootPath()}${BusinessPage.accountCreated}?action=${ApplicationAction.campaignSignIn}`;

    const path = (page: string) => page.replace("/registration/", "");

    return (
        <AuthStyleWrapper>
            <Routes>
                <Route path={path(BusinessPage.campaignSignIn)} element={<SignIn returnUrl={returnUrl} />} />
                <Route path="campaign-sign-up" element={<CampaignSignUp />} />
                <Route path={path(BusinessPage.accountCreated)} element={<AccountCreatedConfirmation />} />
                <Route path={path(BusinessPage.accountNotFound)} element={<AccountNotFound onRetry={retry} />} />
                <Route path="child-accept-invite" element={<ChildSignUp independentSignUp={false} />} />
                <Route path="child-sign-up" element={<ChildSignUp independentSignUp={true} />} />
                <Route path={path(BusinessPage.accountWaitingApproval)} element={<AccountWaitingApproval />} />
            </Routes>
        </AuthStyleWrapper>
    )
}

export default memo(RegistrationLayout);
